import { Tag } from '../../../../components/tag';
import { Promotion } from '../../../../stores/promotion';

const renderActiveStatus = (_: unknown, record: Promotion) => {
    return record.isActive ? (
        <Tag variant="success">Active</Tag>
    ) : (
        <Tag variant="error">Inactive</Tag>
    );
};

export default renderActiveStatus;
